import { ContainerInfoSite } from './styles'

import { usePaymentMethod } from 'src/contexto/hooks/usePaymentMethod'
import { useGlobalContext } from 'src/contexto/contextoGlobal'
import SacHorariosAtendimento from 'src/components/sacHorariosAtendimento'
import {
  arePixOrBilletAvailable,
  getInCashAvailablePaymentMethods,
} from 'src/util/payment'
import {
  IconCreditCard,
  IconPercent,
  IconPhone,
  IconTruck,
} from '@gazin/ecommerce-ui'

export default function InfoSiteFooter({ darkTheme }) {
  const { sacInformation } = useGlobalContext()
  const { payment } = usePaymentMethod()

  const maxInstallments = payment?.creditCard?.numero_parcela ?? 1;

  return (
    <ContainerInfoSite darkTheme={darkTheme}>
      <div className="item">
        <div className="icon">
          <IconCreditCard width="1.875rem" height="1.5625rem" variant="blue" />
        </div>
        <p>
          Pague em até <strong>{maxInstallments}x</strong> no cartão de crédito
        </p>
      </div>
      {arePixOrBilletAvailable(payment) && (
        <div className="item">
          <div className="icon">
            <IconPercent width="1.5625rem" height="1.375rem" />
          </div>
          <p>
            <strong>Desconto</strong> para pagamentos{' '}
            <strong>
              à vista no {getInCashAvailablePaymentMethods(payment)}
            </strong>
          </p>
        </div>
      )}
      <div className="item">
        <div className="icon">
          <IconTruck width="1.5rem" height="1.25rem" />
        </div>
        <p>
          Entregamos em <strong>todo Brasil!</strong>
        </p>
      </div>
      <div className="item">
        <div className="icon">
          <IconPhone width="1.375rem" height="1.25rem" />
        </div>
        <p>
          Atendimento{' '}
          <strong>
            <a
              href={`tel:${sacInformation?.telefone}`}
              as={`tel:${sacInformation?.telefone}`}
              className="link-tel"
            >
              {sacInformation?.telefone}
            </a>
          </strong>
          <br />
          <SacHorariosAtendimento
            horarioAtendimentoDiasUteisInicio={
              sacInformation?.horario_atendimento_dias_uteis_inicio
            }
            horarioAtendimentoDiasUteisFim={
              sacInformation?.horario_atendimento_dias_uteis_fim
            }
            horarioAtendimentoSabadoInicio={
              sacInformation?.horario_atendimento_sabado_inicio
            }
            horarioAtendimentoSabadoFim={
              sacInformation?.horario_atendimento_sabado_fim
            }
            horarioAtendimentoDomingoInicio={
              sacInformation?.horario_atendimento_domingo_inicio
            }
            horarioAtendimentoDomingoFim={
              sacInformation?.horario_atendimento_domingo_fim
            }
          />
        </p>
      </div>
    </ContainerInfoSite>
  )
}
